// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledTable = styled("table")`
	width: 100%;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.table};
	overflow: hidden;
	th {
		white-space: nowrap;
	}
`;

// #####################################################
